import { GridColDef } from "@mui/x-data-grid";
import CustomDataGrid from "../../../../components/ui/customDataGrid/customDataGrid.component";
import { useTranslation } from "react-i18next";
import { Engineering } from "@mui/icons-material";
import { TECHNICIANS_ENDPOINT } from "../../../../consts";
import { useNavigate } from "react-router-dom";
import { useHasPermission } from "../../../../contexts/auth";

export default function TechniciansList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewJobs = useHasPermission("service.view_job");

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: t("Technician"),
      flex: 1,
      minWidth: 220,
    },
    {
      field: "assigned_jobs_count",
      headerName: t("Assigned Jobs"),
      width: 160,
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/service/statistics/technicians/${id}`);
  };

  if (!canViewJobs) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<Engineering />}
      title={t("Technicians")}
      url={TECHNICIANS_ENDPOINT}
      gridSettingsKey="TECHNICIANS"
      columns={columns}
      onRowClick={handleRowClick}
    />
  );
}
